exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.alink[data-v-0f87d1d5]{color:#333\n}", "", {"version":3,"sources":["D:/travel-x/frontworkspace/travel-x/src/components/common/record.vue?vue&type=style&index=0&id=0f87d1d5&scoped=true&lang=css&"],"names":[],"mappings":";AACA,wBAAwB,UAAU;CACjC","file":"record.vue?vue&type=style&index=0&id=0f87d1d5&scoped=true&lang=css&","sourcesContent":["\n.alink[data-v-0f87d1d5]{color:#333\n}"],"sourceRoot":""}]);

// exports
